import axios from 'axios';

class BookmarkError extends Error {
	constructor({ status }, ...params) {
		super(...params);

		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, BookmarkError);
		}

		this.status = status;
	}
}

axios.interceptors.response.use(response => {
	const result = response.data;
	if (result.resultCode === 45009) {
		alert('북마크 가능한 최대 개수를 초과하였습니다.');
		return;
	}

	if (result.resultCode !== 200) {
		throw new BookmarkError({ status: result.resultCode }, result.resultMessage);
	}

	return response;
});

import { loginIfPermissionDenied } from '@src/utils';

export default class {
	constructor() {
		this.host = 'https://cafe.daum.net';

		this.url = {
			bookmark: '/_bookmark',
			tagList: '/_tagList',
			postListByPage: '/_bookmarkListByPaging',
			postListByTagId: '/_bookmarkListByTagId'
		};
	}

	async add(path) {
		return await loginIfPermissionDenied(async () => {
			return (await axios.post(this.url.bookmark, {
				permLink: `${this.host}${path}`,
			})).data;
		});
	}

	async delete(path) {
		return await loginIfPermissionDenied(async () => {
			return (await axios.delete(this.url.bookmark, {
				data: {
					permLink: `${this.host}${path}`
				},
			})).data;
		});
	}

	async load(path) {
		return (await axios.get(this.url.bookmark, {
			params: {
				permLink: `${this.host}${path}`,
			},
		})).data;
	}

	async loadTags() {
		return await loginIfPermissionDenied(async () => {
			return (await axios.get(this.url.tagList)).data;
		});
	}

	async loadPostsByPage(page, unit) {
		return await loginIfPermissionDenied(async () => {
			return (await axios.get(this.url.postListByPage, {
				params: {
					pageNo: page,
					noOfRowsPerPage: unit,
				},
			})).data;
		});
	}

	async loadPostsByTagId(tagId) {
		return await loginIfPermissionDenied(async () => {
			return (await axios.get(this.url.postListByTagId, {
				params: {
					tagId,
				},
			})).data;
		});
	}

	getHost() {
		return this.host;
	}
}
